// What the store's Adjust and Issue dialogs check against (pilot fix, Batch 5
// lane stock). With the kitchen flow on, the server takes stock out of the
// store's own shelf (Main Store), not the item's total across every place —
// the dialogs used to check the total, let the person type a number the store
// does not have, and then show a confusing refusal. With the flag off nothing
// changes: there is one pool, the item's total.
import type { StockLotsResponse } from '@/types'

export const DEFAULT_STORE_NAME = 'Main Store'

export interface StoreShelf {
  /** What the dialog may take out; null while the store's balance is loading. */
  available: number | null
  /** The place's name with the flag on ("Main Store"); null with it off. */
  place: string | null
}

export function storeShelf(
  item: { quantity_on_hand: number },
  lots: StockLotsResponse | undefined,
  kitchenFlow: boolean,
): StoreShelf {
  if (!kitchenFlow) return { available: item.quantity_on_hand, place: null }
  const place = lots?.location_name?.trim() || DEFAULT_STORE_NAME
  const bal = lots?.location_balance
  return { available: typeof bal === 'number' && Number.isFinite(bal) ? bal : null, place }
}

/** True when taking `qty` out would go past what the shelf has (unknown → false: the server checks). */
export function exceedsShelf(shelf: StoreShelf, qty: number | null | undefined): boolean {
  if (shelf.available == null || qty == null || !Number.isFinite(qty)) return false
  return qty > shelf.available
}
